import React from 'react';

import GlobalFonts from '~/theme/fonts.web';

const GlobalStyle = () => {
  return <GlobalFonts />;
};

export default GlobalStyle;
